import { hasAnonymousParam } from 'owa-config/lib/anonymousUtils';
import { redirectToAuthenticatedRoute } from 'owa-config/lib/redirectToAuthenticatedRoute';
import { ATTENDEE_PAGE_KEYWORD } from 'bookwithme-shared/lib/store/schema/BookWithMeRouteConstants';
import { isAnonymousUser } from 'bookings-shared/lib/c2/utils/isAnonymousUser';
import { isMsalEnabledForBusiness } from 'owa-msaljs/lib/isMsalEnabledForBusiness';
import { logUsage } from 'owa-analytics';
import { handleFallbackScenariosForMSALAnonymous } from 'owa-msaljs/lib/utils/handleFallbackScenariosForMSALAnonymous';

export default function runBeforeStart() {
    // If the anonymous param is present, we need to check if we should re-route to the authenticated route.
    // We want to do this in 2 situations:
    // 1. The user is not anonymous (authenticated via another app)
    // 2. The user is attempting to access anything but the attendee page anonymously.
    // For #1, we reroute to give the user a fully authenticated experience since we already know who they are.
    // For #2, we reroute to enforce authentication as there's no supported anonymous scenario other than voting.

    const isAttendeePage = window.location.pathname.indexOf(ATTENDEE_PAGE_KEYWORD) > -1;

    if (!areMSALFlightsEnabled()) {
        /*
        If it is an attendee page and the user is not anonymous, we don't need to redirect to authenticated route
        */
        if (isAttendeePage && !isAnonymousUser()) {
            return Promise.resolve();
        }

        if (hasAnonymousParam() && (!isAnonymousUser() || !isAttendeePage)) {
            logUsage('redirectToAuthenticatedRouteBwm');
            redirectToAuthenticatedRoute();
        }
    }

    if (isAttendeePage) {
        handleFallbackScenariosForMSALAnonymous();
    }

    return Promise.resolve();
}

function areMSALFlightsEnabled(): boolean {
    return isMsalEnabledForBusiness();
}
